import config from 'config/config.prod';

export default {
  ...config,
  gtmKey: 'GTM-MCF5HVX6',
};
